import { injectScript } from '@dbh/dom';
import throwInServerSideRendering from '@dbh/throw-in-server-side-rendering';
import { call, select } from 'redux-saga/effects';
import { PAGE_TYPES } from '@dbh/admindev-constants';
import { makeSelectReactRouterPageType } from '@dbh/routing-redux';
import { makeSelectCurrentCountry } from '@dbh/countries-redux';
import { isPixelEnabled } from '@dbh/site-customizations-redux';
import '@dbh/countries-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import { appCountries } from '@dbh/i18n';
import { makeSelectUserEmail } from '@dbh/user-area-redux';
import createHash from 'create-hash';
import { isCurrentBreakpointMobileDoNotUseInComponents } from '@dbh/breakpoints-context';
import '@dbh/tracking-loggers';
import { makeSelectSearchContext } from '@dbh/webpages-redux';
import { dateObjectToDefaultDateString } from '@dbh/dates';
import { makeSelectSrpCurrentPageHotelsList } from '@dbh/hotels-redux';
import { makeSelectShoppingCartDataAndStatus } from '@dbh/shopping-carts-redux';
import '@dbh/booking-types';

const injectCriteoScript=async()=>{throwInServerSideRendering("injectCriteoScript"),await injectScript("//static.criteo.net/js/ld/ld.js",{async:!0});};var injectCriteoScript$1 = injectCriteoScript;

function*isCriteoEnabled(){return yield call(isPixelEnabled,"criteo")}

/**
 * Push `Criteo's` events to its custom "data layer".
 * @param {Array} criteoEvents `Criteo` events to be pushed.
 */const pushDataToCriteo=function(){window.criteo_q=window.criteo_q||[];for(var a=arguments.length,b=Array(a),c=0;c<a;c++)b[c]=arguments[c];window.criteo_q.push(...b);};var pushDataToCriteo$1 = pushDataToCriteo;

const CRITEO_ACCOUNT_IDS=Object.freeze({GB:"47407",IT:"38195"});const ENABLED_COUNTRIES=Object.keys(CRITEO_ACCOUNT_IDS);({ENABLED:ENABLED_COUNTRIES,DISABLED:appCountries.filter(a=>!ENABLED_COUNTRIES.includes(a))});const CRITEO_EVENTS=Object.freeze({setAccount:"setAccount",setSiteType:"setSiteType",trackTransaction:"trackTransaction",viewHome:"viewHome",viewItem:"viewItem",viewBasket:"viewBasket",setEmail:"setEmail",setHashedEmail:"setHashedEmail",viewSearch:"viewSearch",viewList:"viewList"});

/**
 * Creates `Criteo` event: `setAccount`, for a given country.
 * @param {Immutable.Map} country The current country details.
 * @return {Object?} It is truthy only if `Criteo` is enabled for the given
 * country.
 */const createEventSetAccount=withConformsTo("createEventSetAccount",[],a=>{const b=a.get("code"),c=CRITEO_ACCOUNT_IDS[b];return c?{event:CRITEO_EVENTS.setAccount,account:c}:void 0});var createEventSetAccount$1 = createEventSetAccount;

/**
 * Creates `Criteo` event: `viewSearch`.
 * @param {string} din The first day of the current search date.
 * @param {string} dout The last day of the current search date.
 * @return {Object} .
 */const createEventViewSearch=(a,b)=>({event:CRITEO_EVENTS.viewSearch,nbra:1,nbrc:0,nbri:0,nbrr:1,din:a,dout:b});var createEventViewSearch$1 = createEventViewSearch;

/**
 * Creates `Criteo` event: `setSiteType`. It checks the current device width,
 * to determine if it is mobile or desktop.
 * @return {Object} .
 */const createEventSetSiteType=()=>{const a=isCurrentBreakpointMobileDoNotUseInComponents(),b=a?"m":"d";return {event:CRITEO_EVENTS.setSiteType,type:b}};var createEventSetSiteType$1 = createEventSetSiteType;

/**
 * Returns `date` formatted to not include the time.
 * @param {string} date Non formatted date. @example `2019-12-31T00:00:00`.
 * @return {string} Formatted date. @example `2019-12-31`.
 */const getFormattedDate=a=>{const b=new Date(a);return dateObjectToDefaultDateString(b)};var getFormattedDate$1 = getFormattedDate;

/*
 *
 * Helper: `getSharedValuesFromBookingOrCart`.
 *
 *//**
 * Returns the root price from a booking or cart.
 * @param {Immutable.Map} bookingOrShoppingCart .
 * @return {string} .
 */const getActualPriceFromBookingOrCart=a=>{const b=a.getIn(["pricesTotal","actual"]);return b.toString()},getIdHotelFromBookingOrCart=a=>a.getIn(["hotel","id"]),getSharedValuesFromBookingOrCart=a=>({actualPrice:getActualPriceFromBookingOrCart(a),idHotel:getIdHotelFromBookingOrCart(a)});/**
 * Returns the `id` of the hotel from a booking or cart.
 * @param {Immutable.Map} bookingOrShoppingCart .
 * @return {string} .
 *//**
 * Returns values used by `criteo` pixels that are in the same path in both
 * bookings and shopping carts returned from the `API`.
 * @param {Immutable.Map} bookingOrShoppingCart .
 * @return {Object} .
 */var getSharedValuesFromBookingOrCart$1 = getSharedValuesFromBookingOrCart;

/**
 * Creates the `setEmail` and `setHashedEmail` `criteo` events. The email is
 * created according to the `criteo` documentation. We have always sent the
 * hashed email also in `setEmail`, so we keep that convention.
 * @param {string?} plainTextEmail @example `test@daybreakhotels.com`.
 * @return {Array} Contains the two `criteo` events, ready to be pushed.
 * @see {@link https://support.criteo.com/hc/en-us/articles/203359521-The-structure-of-the-Criteo-OneTag}
 */const createCriteoEventsSetEmail=a=>{// "Please leave this (`email`) parameter blank if an email address is
// unavailable". The above is a quote from the `criteo's` documentation.
let b="";if(a){const c=a.toLowerCase().trim();b=createHash("md5").update(c).digest("hex");}return [{event:CRITEO_EVENTS.setEmail,email:b},{event:CRITEO_EVENTS.setHashedEmail,email:b}]};var createCriteoEventsSetEmail$1 = createCriteoEventsSetEmail;

/**
 * Returns `Criteo` event: `setAccount`.
 * @return {Object?} `undefined` if the current country is not active for `Criteo`.
 * @yields {Object?} .
 */function*getCriteoEventSetAccount(){if(!(yield call(isCriteoEnabled)))return;const a=yield select(makeSelectCurrentCountry()),b=yield call(createEventSetAccount$1,a);return b||void 0}

/**
 * Returns `Criteo` event: `viewList`.
 * @return {Object?} .
 * @yields {Object?} .
 */function*getCriteoEventViewList(){const a=yield select(makeSelectSrpCurrentPageHotelsList());if(a&&!a.isEmpty())// No search results.
{// The values must be strings.
const b=a.map(a=>""+a.get("id")).toJS();return {event:CRITEO_EVENTS.viewList,item:b}}}

/**
 * Returns `Criteo` event: `viewSearch`.
 * @return {Object} .
 * @yields {Object?} .
 */function*getCriteoEventViewSearch(){const a=yield select(makeSelectSearchContext()),b=a.get("searchDate"),c=getFormattedDate$1(b),d=yield call(createEventViewSearch$1,c,c);return d}

/**
 * Creates the `setEmail` and `setHashedEmail` `criteo` events (see the helper).
 * @param {string?} emailToSendForNonSignedInUser This email is sent to `criteo`
 * if the user is not signed in.
 * @return {Array} Contains the two `criteo` events, ready to be pushed.
 * @yields {Array} .
 */function*getCriteoEventsSetEmail(a){const b=yield select(makeSelectUserEmail());return createCriteoEventsSetEmail$1(b||a)}

/**
 * Fires `Criteo` events for: `HomePage`.
 * `Criteo` events fired:
 * A) `setAccount`.
 * B) `setSiteType`.
 * C) `viewHome`.
 * D) `setEmail`.
 * E) `setHashedEmail`.
 * @see {@link https://test.daybreakhotels.com/IT/en-GB}
 * @yields {Object?} .
 */function*fireCriteoPixelViewHomePage(){const a=yield select(makeSelectReactRouterPageType());if(a!==PAGE_TYPES.HomePage)return;const b=yield call(getCriteoEventSetAccount);if(!b)return;const c=yield call(createEventSetSiteType$1),d={event:CRITEO_EVENTS.viewHome},e=yield call(getCriteoEventsSetEmail);yield call(pushDataToCriteo$1,b,c,d,...e);}

/**
 * Fires `Criteo` events in pages using the `SearchResultsPage` template (for now,
 * also `CategoryCityPage` and `PoiPage`).
 * `Criteo` pixel events fired:
 * A) `setAccount`.
 * B) `setSiteType`.
 * C) `viewSearch`.
 * D) `setEmail`.
 * E) `setHashedEmail`.
 * F) `viewList`.
 * @see {@link https://test.daybreakhotels.com/IT/en-GB/22/search?dbhq=(searchContext:(idProductsQuery:2311,location:(idSearchEntity:1,idSearchType:1,searchText:Roma),searchDate:%272019-12-31%27))}
 * @yields {Object?} .
 */function*fireCriteoPixelSearchPages(){const a=yield call(getCriteoEventSetAccount);if(!a)return;const b=yield call(getCriteoEventViewSearch),c=yield call(createEventSetSiteType$1),d=yield call(getCriteoEventsSetEmail),e=yield call(getCriteoEventViewList),f=[a,c,b,...d];e&&f.push(e),yield call(pushDataToCriteo$1,...f);}

/**
 * Fires `Criteo` events in the `HdpPage`.
 * `Criteo` pixel events fired:
 * A) `setAccount`.
 * B) `setSiteType`.
 * C) `viewSearch`.
 * D) `viewItem`.
 * E) `setEmail`.
 * F) `setHashedEmail`.
 * @see {@link https://test.daybreakhotels.com/IT/en-GB/66/day-use-Roma/Welcome-Piram-Hotel?dbhq=(searchContext:(idProductsQuery:2311,searchDate:%272019-12-31%27))}
 * @yields {Object?} .
 */function*fireCriteoPixelPackagesLoaded(){const a=yield call(getCriteoEventSetAccount);if(!a)return;const b=yield call(getCriteoEventViewSearch),c=yield select(makeSelectSearchContext()),d=c.getIn(["location","idSearchEntity"]),e=yield call(createEventSetSiteType$1),f={event:CRITEO_EVENTS.viewItem,item:d},g=yield call(getCriteoEventsSetEmail);yield call(pushDataToCriteo$1,a,e,b,f,...g);}

/**
 * Fires `Criteo` events in the: `BookingFormPage`.
 * `Criteo` pixel events fired:
 * A) `setAccount`.
 * B) `setSiteType`.
 * C) `viewSearch`.
 * D) `viewBasket`.
 * E) `setEmail`.
 * F) `setHashedEmail`.
 * @see {@link https://test.daybreakhotels.com/IT/en-GB/47/finalize-booking?dbhq=(guidShoppingCart:f21ebab9-83c8-4701-8c35-78c02ab86423)}
 * @yields {Object?} .
 */function*fireCriteoPixelShoppingCartLoaded(){const a=yield call(getCriteoEventSetAccount);if(!a)return;const b=yield select(makeSelectShoppingCartDataAndStatus()),c=b.get("loadedData"),d=c.get("day"),e=getFormattedDate$1(d),{idHotel:f,actualPrice:g}=getSharedValuesFromBookingOrCart$1(c),h=yield call(createEventSetSiteType$1),i=yield call(createEventViewSearch$1,e,e),j={event:CRITEO_EVENTS.viewBasket,item:[{id:f,quantity:1,price:g}]},k=yield call(getCriteoEventsSetEmail);yield call(pushDataToCriteo$1,a,h,i,j,...k);}

/**
 * Fires `Criteo` events for: `ShoppingCartLoaded`.
 * `Criteo` events fired:
 * A) `setAccount`.
 * B) `setSiteType`.
 * C) `viewSearch`.
 * D) `trackTransaction` only if the booking state is `RESERVATION_STATUS.C_CANCELLED`.
 * E) `setEmail`.
 * F) `setHashedEmail`.
 * @see {@link https://test.daybreakhotels.com/IT/en-GB/59/booking/overview?dbhq=(guidBooking:%271ef0e7c0-9016-4c96-a8e0-d3613941f56d%27)}
 * @param {Immutable.Map} booking The booking `API` response.
 */const fireCriteoPixelConversion=withConformsTo("fireCriteoPixelConversion",[],function*(a){const b=yield call(getCriteoEventSetAccount);if(!b)return;const c=a.get("day"),d=a.getIn(["user","email"]),e=getFormattedDate$1(c),f=yield call(createEventSetSiteType$1),g=yield call(createEventViewSearch$1,e,e),h=yield call(getCriteoEventsSetEmail,d),i=a.get("idBooking"),{idHotel:j,actualPrice:k}=getSharedValuesFromBookingOrCart$1(a),l={event:CRITEO_EVENTS.trackTransaction,id:i,item:[{id:j,price:k,quantity:1}]};yield call(pushDataToCriteo$1,b,f,g,l,...h);});var fireCriteoPixelConversion$1 = fireCriteoPixelConversion;

export { fireCriteoPixelConversion$1 as fireCriteoPixelConversion, fireCriteoPixelPackagesLoaded, fireCriteoPixelSearchPages, fireCriteoPixelShoppingCartLoaded, fireCriteoPixelViewHomePage, injectCriteoScript$1 as injectCriteoScript };
